<opac-card-item
  *ngIf="loaded"
  [title]="title"
  [author]="record.author"
  [issueDate]="issueDate"
  [cover]="coverDetails"
  [link]="record | infoUrl: { rhId: hold.rssRhId }">
  <opac-card-item-social>
    <app-rating class="interactions__rating" [record]="record"></app-rating>
    <app-favorite-button *ngIf="!record?.fromBookClub" [recordId]="record?.id"></app-favorite-button>
    <app-more-option-button [recordItem]="record" [isHoldItem]="true" [holdItem]="hold"></app-more-option-button>
  </opac-card-item-social>

  <opac-card-item-details>
    <opac-card-item-detail [label]="'user.holds.status' | translate">
      <span class="status" [ngClass]="hold.status"> {{ 'user.holds.statuses.' + hold.status | translate }} </span>
    </opac-card-item-detail>

    <opac-card-item-detail *ngFor="let detail of cardItemDetails" [label]="detail.label | translate">
      {{ detail.value }}
    </opac-card-item-detail>
  </opac-card-item-details>

  <app-record-buttons
    *ngIf="!isPhysicalItem && showButtons"
    [record]="record"
    [holdItem]="hold"
    [config]="buttonConfig"
    [rssItem]="rssItem">
  </app-record-buttons>
  <app-record-buttons
    *ngIf="isPhysicalItem && showButtons"
    [holdItem]="hold"
    [record]="record"
    [physicalRecord]="physicalRecord"
    [config]="buttonConfig"
    [rssItem]="rssItem">
  </app-record-buttons>
</opac-card-item>
